import { ProductScriptSections } from '../components/product/ProductScriptSections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildProductScriptPageSchema } from '../lib/schema';
import { PRODUCT_SCRIPT_META } from '../lib/seo';
import '../styles/product-landing.css';

export function ProductScriptPage() {
  return (
    <>
      <PageSeo meta={PRODUCT_SCRIPT_META} />
      <JsonLd data={buildProductScriptPageSchema()} />
      <MarketingLandingShell>
        <ProductScriptSections />
      </MarketingLandingShell>
    </>
  );
}
